<template>
  <span>{{ persianDate }}</span>
</template>
<script>
export default {
  props: ["date"],
  data() {
    return {
      persianDate: ""
    };
  },
  created() {
    this.conventToPersian();
  },
  methods: {
    conventToPersian() {
      this.persianDate = this.$moment(this.date, "YYYY/MM/DD HH:mm")
        .locale("fa")
        .format("HH:mm - YYYY/MM/DD");
    }
  }
};
</script>
